export const setInToStorage = (data) => {
    Object.keys(data).forEach(item => {
        localStorage.setItem(item, data[item])
    })
};

export const getFromStorage = key => {
    return localStorage.getItem(key);
};

export const clientId = '834409604454-6gs7ilj2545vbhfpmjjp3bfq5rnv8s8v.apps.googleusercontent.com';